import request from '@/utils/request'
let baseUrl = '/api/system/'
export function getList() {
    return request({
      url: baseUrl+'province',
      method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/province.js